import { Login } from "./Login";

export class DoLogoutUseCase {
  static async doLogout(login: Login): Promise<boolean> {
    localStorage.setItem(Login.LOGGED_USER_KEY, "");
    return await login.doLogout();
  }
}
